import { CompanyColumn, CompanyData, CompanyStatus } from "./types";
import { mapEnum } from "@/utils/strings";

export const companyStatuses = mapEnum(CompanyStatus, (value) => value);
export const companyColumnKeys = Object.values(CompanyColumn);

// The server resolves the parent's name, so it no longer depends on the parent
// being among the companies loaded on the current page.
export const getParentCompanyDisplayName = (
  company: Pick<CompanyData, "parentCompanyName">,
  fallback: string
): string => company.parentCompanyName || fallback;

// The field the API SORTS the parent company on. Filtering does not use it: the
// filter is a picker and sends the column's own key, `parentCompany`, as a list of
// ids. Sorting cannot do that, because the id orders by insertion rather than by
// anything the column displays.
export const PARENT_COMPANY_NAME_FIELD = "parentCompanyName";

// Columns whose id is not a field the API can sort on. Applies to sorting and to
// the export's sort order only — filter keys are declared on each filter option and
// are unaffected. Shared by the table and the export so a CSV comes out in the order
// shown on screen.
export const COMPANIES_SORT_FIELD_BY_COLUMN: Record<string, string> = {
  [CompanyColumn.PARENT_COMPANY]: PARENT_COMPANY_NAME_FIELD
};
